module.exports = __webpack_public_path__ + "assets/images/QRcode.4bb840263ae6daf5459b761b371061ae.png";